import { gql } from '@apollo/client';

export const GET_CONFIGURATION_LIST = gql`
  query GetConfigurationList($filter: ConfigurationFilterInput) {
    getConfigurationList(filter: $filter) {
      success
      message
      configurations {
        id
        name
        value
        inputType
        createdAt
        createdBy
        createdByUser {
          id
          name
          userName
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          name
          userName
        }
      }
      total
    }
  }
`;

export const GET_CONFIGURATION = gql`
  query GetConfiguration($id: String) {
    getConfiguration(id: $id) {
      id
      name
      value
      inputType
      createdAt
      createdBy
      createdByUser {
        id
        name
        userName
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        name
        userName
      }
    }
  }
`;

export const UPDATE_CONFIGURATION = gql`
  mutation UpdateConfiguration($input: UpdateConfigurationInput!) {
    updateConfiguration(input: $input) {
      success
      message
      configuration {
        id
        name
        value
        inputType
        createdAt
        createdBy
        createdByUser {
          id
          name
          userName
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          name
          userName
        }
      }
    }
  }
`;

export const CREATE_CONFIGURATION = gql`
  mutation CreateConfiguration($input: CreateConfigurationInput!) {
    createConfiguration(input: $input) {
      success
      message
      configuration {
        id
        name
        value
        inputType
        createdAt
        createdBy
        createdByUser {
          id
          name
          userName
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          name
          userName
        }
      }
    }
  }
`;

export const DELETE_CONFIGURATION = gql`
  mutation DeleteConfiguration($input: DeleteConfigurationInput!) {
    deleteConfiguration(input: $input) {
      success
      message
    }
  }
`;